// export const PLATFORMS = ["PC", "SWITCH", "PLAYSTATION", "XBOX"];
// export const REGIONS = ["EUROPE", "AMERICAS", "ASIA"];
// export const MODES = ["SOFTCORE", "HARDCORE"];
// export const LADDER = ["NON LADDER", "LADDER"];

// export const GAMES = ["Diablo 4", "Diablo 2 ROTW"]

import {CURRENCY_NAMES, CURRENCY_TYPES} from "./D4Enums";
import {D4_MY_SALES_TABLE_HEADERS} from "../TableHeaders";

export const DIABLO_4 = "Diablo 4";

export const GAMES = [DIABLO_4]

export const getCurrencyNames = function (game) {
    switch (game) {
        case DIABLO_4:
            return CURRENCY_NAMES;
        default:
            throw "Unsupported game" + game;
    }
}

export const getCurrencyTypes = function (game) {
    switch (game) {
        case DIABLO_4:
            return CURRENCY_TYPES;
        default:
            throw "Unsupported game" + game;
    }
}

export const getMySalesTableHeaders = function (game) {
    switch (game) {
        case DIABLO_4:
            return D4_MY_SALES_TABLE_HEADERS;
        default:
            throw "Unsupported game" + game;
    }
}